module.exports = __webpack_public_path__ + "img/morocco.08a40593.svg";